module.exports = __webpack_public_path__ + "img/kh24.b6f622e6.png";